import { Role } from "@app/role";

export class UserDataDto {
  id: string = "";
  email: string = "";
  assignedRole?: Role;
  invitationCompletedAt?: Date;
  invitedBy?: string;
}
